<section data-test="1BdGpnOC">
  <h2 data-test="C3HgdXuf">Targets</h2>
  <div data-test="gtwaLFK3" class="row gutters-20">
    <div data-test="9BMDRHXD" class="col">
      <div data-test="ZH2U8dWi" class="block block_shadow">
        <div data-test="iJpUr383" class="modules-container">
          <div data-test="UUDrzlZp" class="target">
            <div data-test="kLlD7Wfj" class="row align-items-end gutters-20">
              <div data-test="h3607Nxc" class="col-auto">
                <div data-test="0uGwcrAK" class="target__img text-brand">
                  <svg
                    data-test="DuLWcjV_"
                    class="icon__icon-target-gross"
                    width="59.5px"
                    height="60px"
                  >
                    <use xlink:href="#icon-target-gross"></use>
                  </svg>
                </div>
              </div>
              <div data-test="scNh-Xsq" class="col-7">
                <div data-test="4jwj6McY" class="target__text">
                  <label data-test="CpHpQCHT" class="form-group__label" for="input-3">
                    <b data-test="cPgdM4Ik">Gross margin target</b>
                    <span data-test="I9EdhkI_" class="text-light">( optional )</span>
                  </label>
                  <input
                    data-test="j6bCoUKu"
                    [specialCharacters]="['%']"
                    [dropSpecialCharacters]="true"
                    mask="percent"
                    suffix="%"
                    type="text"
                    [ngrxFormControlState]="teamTaskForm.controls.grossMarginTarget"
                    class="input input_lg input_bb font-weight-bold"
                    placeholder="75%"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-test="sgUszvgy" class="col">
      <div data-test="1MZ2k1J7" class="block block_shadow">
        <div data-test="5QwIr6YW" class="modules-container">
          <div data-test="KngsyEMa" class="target">
            <div data-test="ME51Wb3Z" class="row align-items-end gutters-20">
              <div data-test="9yCbD2Lf" class="col-auto">
                <div data-test="MUPxcIGH" class="target__img text-brand">
                  <svg
                    data-test="GhnY0oU-"
                    class="icon__icon-target-netto"
                    width="59.5px"
                    height="60px"
                  >
                    <use xlink:href="#icon-target-netto"></use>
                  </svg>
                </div>
              </div>
              <div data-test="Byc5kUZ8" class="col-7">
                <div data-test="XGtd-TLR" class="target__text">
                  <label data-test="-wSTcdgt" class="form-group__label" for="input-4">
                    <b data-test="uYlfakiw">Netto margin target</b>
                    <span data-test="Pxhlo4HY" class="text-light">( optional )</span>
                  </label>
                  <input
                    data-test="yNXshFOZ"
                    [specialCharacters]="['%']"
                    [dropSpecialCharacters]="true"
                    mask="percent"
                    suffix="%"
                    type="text"
                    [ngrxFormControlState]="teamTaskForm.controls.nettoMarginTarget"
                    class="input input_lg input_bb font-weight-bold"
                    placeholder="55%"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
